var _desc, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBarcode(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 576,
    height: 118,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "http://themesbrand.com/\r\n   ")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "barcode",
    fill: "#000000"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 576,
    height: 118,
    fill: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 4,
    height: 100
  }), /*#__PURE__*/React.createElement("rect", {
    x: 6,
    y: 0,
    width: 2,
    height: 100
  }), /*#__PURE__*/React.createElement("rect", {
    x: 12,
    y: 0,
    width: 2,
    height: 100
  }), /*#__PURE__*/React.createElement("rect", {
    x: 22,
    y: 0,
    width: 2,
    height: 100
  }), /*#__PURE__*/React.createElement("rect", {
    x: 28,
    y: 0,
    width: 4,
    height: 100
  }), /*#__PURE__*/React.createElement("rect", {
    x: 40,
    y: 0,
    width: 2,
    height: 100
  }), /*#__PURE__*/React.createElement("rect", {
    x: 44,
    y: 0,
    width: 2,
    height: 100
  }), /*#__PURE__*/React.createElement("rect", {
    x: 50,
    y: 0,
    width: 8,
    height: 100
  }), /*#__PURE__*/React.createElement("rect", {
    x: 60,
    y: 0,
    width: 2,
    height: 100
  }), /*#__PURE__*/React.createElement("rect", {
    x: 66,
    y: 0,
    width: 2,
    height: 100
  }), /*#__PURE__*/React.createElement("rect", {
    x: 72,
    y: 0,
    width: 8,
    height: 100
  }), /*#__PURE__*/React.createElement("rect", {
    x: 82,
    y: 0,
    width: 2,
    height: 100
  }), /*#__PURE__*/React.createElement("rect", {
    x: 88,
    y: 0,
    width: 2,
    height: 100
  }), /*#__PURE__*/React.createElement("rect", {
    x: 92,
    y: 0,
    width: 2,
    height: 100
  }), /*#__PURE__*/React.createElement("rect", {
    x: 98,
    y: 0,
    width: 8,
    height: 100
  }), /*#__PURE__*/React.createElement("rect", {
    x: 110,
    y: 0,
    width: 6,
    height: 100
  }), /*#__PURE__*/React.createElement("rect", {
    x: 120,
    y: 0,
    width: 2,
    height: 100
  }), /*#__PURE__*/React.createElement("rect", {
    x: 126,
    y: 0,
    width: 4,
    height: 100
  }), /*#__PURE__*/React.createElement("rect", {
    x: 132,
    y: 0,
    width: 2,
    height: 100
  }), /*#__PURE__*/React.createElement("rect", {
    x: 136,
    y: 0,
    width: 6,
    height: 100
  }), /*#__PURE__*/React.createElement("rect", {
    x: 146,
    y: 0,
    width: 4,
    height: 100
  }), /*#__PURE__*/React.createElement("rect", {
    x: 154,
    y: 0,
    width: 2,
    height: 100
  }), /*#__PURE__*/React.createElement("rect", {
    x: 158,
    y: 0,
    width: 6,
    height: 100
  }), /*#__PURE__*/React.createElement("rect", {
    x: 168,
    y: 0,
    width: 4,
    height: 100
  }), /*#__PURE__*/React.createElement("rect", {
    x: 176,
    y: 0,
    width: 2,
    height: 100
  }), /*#__PURE__*/React.createElement("rect", {
    x: 182,
    y: 0,
    width: 8,
    height: 100
  }), /*#__PURE__*/React.createElement("rect", {
    x: 192,
    y: 0,
    width: 2,
    height: 100
  }), /*#__PURE__*/React.createElement("rect", {
    x: 198,
    y: 0,
    width: 2,
    height: 100
  }), /*#__PURE__*/React.createElement("rect", {
    x: 204,
    y: 0,
    width: 4,
    height: 100
  }), /*#__PURE__*/React.createElement("rect", {
    x: 216,
    y: 0,
    width: 2,
    height: 100
  }), /*#__PURE__*/React.createElement("rect", {
    x: 220,
    y: 0,
    width: 2,
    height: 100
  }), /*#__PURE__*/React.createElement("rect", {
    x: 224,
    y: 0,
    width: 4,
    height: 100
  }), /*#__PURE__*/React.createElement("rect", {
    x: 232,
    y: 0,
    width: 2,
    height: 100
  }), /*#__PURE__*/React.createElement("rect", {
    x: 242,
    y: 0,
    width: 8,
    height: 100
  }), /*#__PURE__*/React.createElement("rect", {
    x: 252,
    y: 0,
    width: 6,
    height: 100
  }), /*#__PURE__*/React.createElement("rect", {
    x: 260,
    y: 0,
    width: 2,
    height: 100
  }), /*#__PURE__*/React.createElement("rect", {
    x: 264,
    y: 0,
    width: 2,
    height: 100
  }), /*#__PURE__*/React.createElement("rect", {
    x: 268,
    y: 0,
    width: 4,
    height: 100
  }), /*#__PURE__*/React.createElement("rect", {
    x: 276,
    y: 0,
    width: 2,
    height: 100
  }), /*#__PURE__*/React.createElement("rect", {
    x: 286,
    y: 0,
    width: 2,
    height: 100
  }), /*#__PURE__*/React.createElement("rect", {
    x: 290,
    y: 0,
    width: 8,
    height: 100
  }), /*#__PURE__*/React.createElement("rect", {
    x: 302,
    y: 0,
    width: 2,
    height: 100
  }), /*#__PURE__*/React.createElement("rect", {
    x: 308,
    y: 0,
    width: 2,
    height: 100
  }), /*#__PURE__*/React.createElement("rect", {
    x: 314,
    y: 0,
    width: 2,
    height: 100
  }), /*#__PURE__*/React.createElement("rect", {
    x: 324,
    y: 0,
    width: 4,
    height: 100
  }), /*#__PURE__*/React.createElement("rect", {
    x: 330,
    y: 0,
    width: 2,
    height: 100
  }), /*#__PURE__*/React.createElement("rect", {
    x: 336,
    y: 0,
    width: 2,
    height: 100
  }), /*#__PURE__*/React.createElement("rect", {
    x: 342,
    y: 0,
    width: 8,
    height: 100
  }), /*#__PURE__*/React.createElement("rect", {
    x: 352,
    y: 0,
    width: 2,
    height: 100
  }), /*#__PURE__*/React.createElement("rect", {
    x: 358,
    y: 0,
    width: 2,
    height: 100
  }), /*#__PURE__*/React.createElement("rect", {
    x: 362,
    y: 0,
    width: 4,
    height: 100
  }), /*#__PURE__*/React.createElement("rect", {
    x: 374,
    y: 0,
    width: 4,
    height: 100
  }), /*#__PURE__*/React.createElement("rect", {
    x: 386,
    y: 0,
    width: 2,
    height: 100
  }), /*#__PURE__*/React.createElement("rect", {
    x: 390,
    y: 0,
    width: 2,
    height: 100
  }), /*#__PURE__*/React.createElement("rect", {
    x: 396,
    y: 0,
    width: 2,
    height: 100
  }), /*#__PURE__*/React.createElement("rect", {
    x: 406,
    y: 0,
    width: 2,
    height: 100
  }), /*#__PURE__*/React.createElement("rect", {
    x: 412,
    y: 0,
    width: 4,
    height: 100
  }), /*#__PURE__*/React.createElement("rect", {
    x: 418,
    y: 0,
    width: 2,
    height: 100
  }), /*#__PURE__*/React.createElement("rect", {
    x: 424,
    y: 0,
    width: 4,
    height: 100
  }), /*#__PURE__*/React.createElement("rect", {
    x: 432,
    y: 0,
    width: 6,
    height: 100
  }), /*#__PURE__*/React.createElement("rect", {
    x: 440,
    y: 0,
    width: 2,
    height: 100
  }), /*#__PURE__*/React.createElement("rect", {
    x: 450,
    y: 0,
    width: 2,
    height: 100
  }), /*#__PURE__*/React.createElement("rect", {
    x: 454,
    y: 0,
    width: 4,
    height: 100
  }), /*#__PURE__*/React.createElement("rect", {
    x: 462,
    y: 0,
    width: 2,
    height: 100
  }), /*#__PURE__*/React.createElement("rect", {
    x: 470,
    y: 0,
    width: 8,
    height: 100
  }), /*#__PURE__*/React.createElement("rect", {
    x: 480,
    y: 0,
    width: 2,
    height: 100
  }), /*#__PURE__*/React.createElement("rect", {
    x: 484,
    y: 0,
    width: 8,
    height: 100
  }), /*#__PURE__*/React.createElement("rect", {
    x: 494,
    y: 0,
    width: 6,
    height: 100
  }), /*#__PURE__*/React.createElement("rect", {
    x: 502,
    y: 0,
    width: 2,
    height: 100
  }), /*#__PURE__*/React.createElement("rect", {
    x: 506,
    y: 0,
    width: 2,
    height: 100
  }), /*#__PURE__*/React.createElement("rect", {
    x: 510,
    y: 0,
    width: 6,
    height: 100
  }), /*#__PURE__*/React.createElement("rect", {
    x: 520,
    y: 0,
    width: 4,
    height: 100
  }), /*#__PURE__*/React.createElement("rect", {
    x: 528,
    y: 0,
    width: 6,
    height: 100
  }), /*#__PURE__*/React.createElement("rect", {
    x: 536,
    y: 0,
    width: 4,
    height: 100
  }), /*#__PURE__*/React.createElement("rect", {
    x: 546,
    y: 0,
    width: 2,
    height: 100
  }), /*#__PURE__*/React.createElement("rect", {
    x: 550,
    y: 0,
    width: 4,
    height: 100
  }), /*#__PURE__*/React.createElement("rect", {
    x: 560,
    y: 0,
    width: 6,
    height: 100
  }), /*#__PURE__*/React.createElement("rect", {
    x: 568,
    y: 0,
    width: 2,
    height: 100
  }), /*#__PURE__*/React.createElement("rect", {
    x: 572,
    y: 0,
    width: 4,
    height: 100
  }), /*#__PURE__*/React.createElement("text", {
    x: 288,
    y: 118,
    textAnchor: "middle",
    fontFamily: "Helvetica",
    fontSize: 16,
    fill: "#000000"
  }, "\r\n         http://themesbrand.com/\r\n      "))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBarcode);
export default __webpack_public_path__ + "static/media/barcode.e5f6d6b3518ea83de1a8fbf7f8e91c06.svg";
export { ForwardRef as ReactComponent };